module.exports = __webpack_public_path__ + "static/media/ReportMt.d52f5a94.svg";